import React, { useState } from "react";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Switch,
    TextField,
    Typography,
} from "@mui/material";
import ImagePickerDialog from "../ImagePickerDialog";

const GRID_SIZES = [2, 3, 4, 5];

const normalizeGridSize = (value, fallback) => {
    const number = Number(value);
    return GRID_SIZES.includes(number) ? number : fallback;
};

const QuestionFormPuzzle = ({ value, onChange }) => {
    const v = value || {};
    const [pickerOpen, setPickerOpen] = useState(false);

    const rows = normalizeGridSize(v.rows, 3);
    const columns = normalizeGridSize(v.columns, 3);

    const onPickImage = (img) => {
        onChange({
            ...v,
            imgPath: img.url,
        });
        setPickerOpen(false);
    };

    return (
        <Stack spacing={2}>
            <Typography variant="subtitle2">Пазл (п'ятнашки)</Typography>

            <TextField
                label="Підзаголовок"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="Текст завдання"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                helperText="Наприклад: Складіть зображення з частинок."
                fullWidth
                multiline
                minRows={3}
            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                <TextField
                    label="URL зображення"
                    value={v.imgPath || ""}
                    onChange={(e) => onChange({ ...v, imgPath: e.target.value })}
                    fullWidth
                />
                <Button variant="outlined" onClick={() => setPickerOpen(true)} sx={{ minWidth: 180 }}>
                    Обрати зображення
                </Button>
            </Stack>

            {v.imgPath && (
                <Box
                    component="img"
                    src={v.imgPath}
                    alt="Puzzle preview"
                    sx={{
                        width: "100%",
                        maxHeight: 320,
                        objectFit: "contain",
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        backgroundColor: "background.default",
                    }}
                />
            )}

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <FormControl fullWidth>
                    <InputLabel id="puzzle-rows-label">Рядки</InputLabel>
                    <Select
                        labelId="puzzle-rows-label"
                        label="Рядки"
                        value={rows}
                        onChange={(e) => onChange({ ...v, rows: Number(e.target.value) })}
                    >
                        {GRID_SIZES.map((size) => (
                            <MenuItem key={size} value={size}>
                                {size}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <InputLabel id="puzzle-columns-label">Колонки</InputLabel>
                    <Select
                        labelId="puzzle-columns-label"
                        label="Колонки"
                        value={columns}
                        onChange={(e) => onChange({ ...v, columns: Number(e.target.value) })}
                    >
                        {GRID_SIZES.map((size) => (
                            <MenuItem key={size} value={size}>
                                {size}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Stack>

            <FormControlLabel
                control={
                    <Switch
                        checked={v.showPreview !== false}
                        onChange={(e) => onChange({ ...v, showPreview: e.target.checked })}
                    />
                }
                label="Показувати учню прев'ю зображення"
            />

            <Typography variant="body2" color="text.secondary">
                Рекомендація: для молодших учнів використовуйте 3x3, для складніших завдань - 4x4.
            </Typography>

            <ImagePickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickImage}
            />
        </Stack>
    );
};

export default QuestionFormPuzzle;
